import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue-demi';
import {
  AbSection,
  AbContainer,
  AbTitle,
  AbLink,
  AbDescription,
  AbSectionLayout,
  AbGrid,
  AbGridItem,
} from '../../../ui';
import useBreakpoint from '../../../../composables/useBreakpoint';
import { Spacing } from '../../../../helpers/shared-props';
import { CdnImg } from '@webplatform/cdn-image';
import { TextAlign } from '../../../../types';
import { useSectionAnalytics } from '../../../../analytics';

interface Props {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  items: {
    title?: string | null;
    creative_name?: string | null;
    link?: string | null;
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    width?: number | null;
    height?: number | null;
    order?: number | null;
    orderMobile?: number | null;
    contentAlign?: TextAlign | null;
    bgGradient?: boolean | null;
  }[];
  spacing?: Spacing | null;
  disableItemsOverlay?: boolean | null;
  analytics_placement?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionGrid',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: null,
    items: null,
    spacing: null,
    disableItemsOverlay: { type: [Boolean, null] },
    analytics_placement: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  items: {
    title?: string | null;
    creative_name?: string | null;
    link?: string | null;
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    width?: number | null;
    height?: number | null;
    order?: number | null;
    orderMobile?: number | null;
    contentAlign?: TextAlign | null;
    bgGradient?: boolean | null;
  }[];
  spacing?: Spacing | null;
  disableItemsOverlay?: boolean | null;
  analytics_placement?: string | null;
};



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const sectionItems = computed(() =>
  props.items
    .map((item, i) => {
      const order = item.order ?? i;
      const orderMobile = item.orderMobile ?? order;

      return { ...item, order, orderMobile };
    })
    .sort((a, b) =>
      isDesktop.value ? a.order - b.order : a.orderMobile - b.orderMobile,
    ),
);

// Analytics
const sectionRef = ref<HTMLElement | null>(null);
const analyticItems = computed(() =>
  (props.items ?? []).map((item) => ({
    destination_url: item.link ?? '',
    creative_name: item.creative_name ?? item.title ?? '',
  })),
);

const { trackSelectItem } = useSectionAnalytics(
  sectionRef,
  {
    placement: props.analytics_placement ?? '',
    items: analyticItems.value,
  },
  { mode: 'section', sectionName: 'CardSectionGrid' },
);

const handleItemClick = (index: number) => {
  trackSelectItem(index);
};

return { __sfc: true,props, isDesktop, sectionItems, sectionRef, analyticItems, trackSelectItem, handleItemClick, AbSection, AbContainer, AbTitle, AbLink, AbDescription, AbSectionLayout, AbGrid, AbGridItem, CdnImg }
}

})